import { MenuItem, MenuButton, MenuItems, Menu } from '@headlessui/react';
import IconSvg from 'src/assets/icons/IconSvg';
import { useViewport } from 'src/context/ViewportContext';
import type { RaffleSortOption } from 'src/types/raffleFilters';

interface Props {
  selectedSort?: RaffleSortOption;
  onSortChange?: (sort: RaffleSortOption) => void;
}

const SORT_OPTIONS: { key: RaffleSortOption; label: string; icon?: 'trianglesUpS' | 'trianglesDownS' }[] = [
  { key: 'default', label: 'Default' },
  { key: 'recently_added', label: 'Recently Added' },
  { key: 'expiring_soon', label: 'Expiring Soon' },
  { key: 'tickets_remaining_asc', label: 'Tickets Remaining', icon: 'trianglesUpS' },
  { key: 'tickets_remaining_desc', label: 'Tickets Remaining', icon: 'trianglesDownS' },
  { key: 'ticket_price_asc', label: 'Ticket Price', icon: 'trianglesUpS' },
  { key: 'ticket_price_desc', label: 'Ticket Price', icon: 'trianglesDownS' },
  { key: 'floor_price_asc', label: 'Floor Price', icon: 'trianglesUpS' },
  { key: 'floor_price_desc', label: 'Floor Price', icon: 'trianglesDownS' },
];

const SortByMenu = ({ selectedSort, onSortChange }: Props) => {
  const { isMobile } = useViewport();

  return (
    <Menu>
      <MenuButton className="w-[34px] xl:w-[185px] rounded-lg bg-grayscale-900 border border-grayscale-700 flex items-center justify-between px-2.5 xl:px-4 h-[34px] xl:h-[48px] data-[open]:bg-grayscale-700 group">
        <div className="flex gap-2 items-center text-grayscale-300">
          <IconSvg icon={isMobile ? 'sortingS' : 'sortingM'} />
          <div className="hidden text-lg font-medium xl:block">Sort by</div>
        </div>
        <IconSvg
          icon="arrowDownS"
          className="text-grayscale-300 group-data-[open]:rotate-180 transition-all duration-200 xl:block hidden"
        />
      </MenuButton>

      <MenuItems
        transition
        anchor="bottom end"
        className="z-50 w-[185px] bg-grayscale-900 mt-1.5 rounded-lg text-grayscale-400 py-2 px-4 space-y-3"
      >
        {SORT_OPTIONS.map((opt) => (
          <MenuItem as="div" key={opt.key}>
            <button
              className={`flex gap-2 items-center ${
                selectedSort === opt.key ? 'text-grayscale-200' : ''
              }`}
              onClick={() => onSortChange?.(opt.key)}
            >
              <span>{opt.label}</span>
              {opt.icon && <IconSvg icon={opt.icon} />}
            </button>
          </MenuItem>
        ))}
      </MenuItems>
    </Menu>
  );
};

export default SortByMenu;
